//
// AnalysisRole.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./Role";

var AnalysisRole = createModule("gtl::AnalysisRole", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::Role"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        setStyle: [0,1],
    },
    {
        _create_v: [4],
        _create_s: [4,7],
        _create_o: [4,1],
        getSharedFrequencyRole: [1],
    },
    ,
    ["_create"]
]);
export default AnalysisRole;
